module.exports = __webpack_public_path__ + "static/media/celebration.5a7d8a26.jpg";